import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TodosRoutingModule } from './todos-routing.module';
import { TodoListComponent } from './components/todo-list/todo-list.component';
import { TodoFormComponent } from './components/todo-form/todo-form.component';
import { AddSubTodoDialogComponent } from './components/add-subtodo-dialog/add-subtodo-dialog.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SearchComponent } from '../../shared/components/search/search.component';


@NgModule({
  declarations: [
    TodoListComponent,
    TodoFormComponent,
    AddSubTodoDialogComponent
  ],
  imports: [
    CommonModule,
    TodosRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule, // This provides the native DateAdapter
    MatSelectModule,
    MatOptionModule, // This is optional, often included via MatSelectModule
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    SearchComponent,
  ],
  exports: [
    AddSubTodoDialogComponent
  ]
})
export class TodosModule { }
